import LocalizedStrings from 'react-localization';
import titlesJson from 'simpl-i18n/locales/notifications/titles';
import messagesJson from 'simpl-i18n/locales/notifications/messages';
import projectStatusJson from 'simpl-i18n/locales/notifications/projectStatus';
import descriptionsJson from 'simpl-i18n/locales/notifications/descriptions';

export const titles = new LocalizedStrings(titlesJson);
export const messages = new LocalizedStrings(messagesJson);
export const projectStatus = new LocalizedStrings(projectStatusJson);
export const descriptions = new LocalizedStrings(descriptionsJson);



// WEBPACK FOOTER //
// ./src/locales/notifications.js